import {
  DISCOUNT_TYPE,
  DiscountComponent,
  DiscountInfo,
  IClientDiscountManager,
  IProductDiscountSetting,
  ItemBillingDiscountInfo,
} from '../../../all-types'

class ProductDiscountCalc {
  billDiscount: ItemBillingDiscountInfo
  discountSettings: IProductDiscountSetting
  parentDiscountSettings: IClientDiscountManager

  constructor(
    psettings: IClientDiscountManager,
    settings: IProductDiscountSetting,
    billDiscount: ItemBillingDiscountInfo = {
      amountAfterDiscount: 0,
      amountBeforeDiscount: 0,
      discountAmount: 0,
      discountsInfo: [],
      isDiscountApplied: false,
    }
  ) {
    this.parentDiscountSettings = psettings
    this.discountSettings = settings
    this.billDiscount = billDiscount
  }

  static getDiscountRecord = (
    amount: number,
    discount: DiscountComponent,
    index = 0
  ): DiscountInfo => {
    let discountAmount = 0
    if (discount.discountType === DISCOUNT_TYPE.PERCENTAGE) {
      discountAmount = Number(
        ((amount / 100) * discount.applicableDiscount).toFixed(4)
      )
    } else {
      // CASH
      discountAmount = Number(amount - discount.applicableDiscount)
    }
    return {
      discountSno: index,
      discountComponent: discount,
      amountBeforeDiscount: amount,
      discountAmount: discountAmount,
      amountAfterDiscount: amount - discountAmount, //amountBeforeTax
    }
  }

  getDiscountCompsFromParent = (appliedComponent: string[]) => {
    let discountComp: DiscountComponent[] = []
    try {
      const { activeDiscounts } = this.parentDiscountSettings
      appliedComponent?.forEach((discountId) => {
        if (
          activeDiscounts &&
          activeDiscounts[discountId] &&
          activeDiscounts[discountId].isActive
        ) {
          discountComp.push(activeDiscounts[discountId])
        }
      })
      discountComp = discountComp.sort(
        (a, b) => a.applicableDiscount - b.applicableDiscount
      )
    } catch (e) {
      console.error(e)
    }
    return discountComp
  }

  applyDiscountByProductSettings = (
    amount: number,
    fullBillDicountComponents: string[] = []
  ) => {
    try {
      console.log('<-------------- processing discount -------------->')
      this.billDiscount.amountBeforeDiscount = amount
      const {
        isDiscountsApplicable,
        considerStrictProductSettings,
        allowDiscountOnTotalBill,
      } = this.parentDiscountSettings

      if(isDiscountsApplicable) {
        console.log('(Parent Settings) Discounts are allowed');

        if (considerStrictProductSettings) {
          console.log('(Parent Settings) Only Product Settings are applicable');
          const {
            enableStrictRules,
            isDiscountApplicable,
            enableProductDiscount,
            appliedComponent,
            allowTotalBillDiscount
          } = this.discountSettings
          if (enableStrictRules && isDiscountApplicable) {
            console.log('(Enforce Product Dicount) Discount is applicable');
            const totalComponents = [...appliedComponent];
            if(allowTotalBillDiscount) {
              console.log('(Enforce Product Dicount) Allowing Total Bill Discount');
              totalComponents.push(...fullBillDicountComponents)
            }
           
            if (enableProductDiscount && totalComponents?.length > 0) {
              this.billDiscount.isDiscountApplied = true
              let calAmount = amount
              const discountComp: DiscountComponent[] =
                this.getDiscountCompsFromParent(totalComponents)
              discountComp?.forEach((discount, index) => {
                const discountInfo = ProductDiscountCalc.getDiscountRecord(
                  calAmount,
                  discount,
                  index
                )
                calAmount = discountInfo.amountAfterDiscount
                this.billDiscount.discountAmount += discountInfo.discountAmount
                this.billDiscount.discountsInfo.push(discountInfo)
              })
              this.billDiscount.amountAfterDiscount = calAmount
            } else if (
              allowDiscountOnTotalBill &&
              fullBillDicountComponents?.length
            ) {
            } else {
              this.billDiscount.isDiscountApplied = false
              this.billDiscount.amountAfterDiscount = amount
            }
          } else {
            console.log('(Enforce Product Dicount) No discounts applicable');
            this.billDiscount.isDiscountApplied = false
            this.billDiscount.amountAfterDiscount = amount
          }
        }  else if (
          allowDiscountOnTotalBill &&
          fullBillDicountComponents?.length
        ) {
          console.log('(Parent Settings) Applying discount on total bill')
          this.billDiscount.isDiscountApplied = true
          let calAmount = amount
          const discountComp: DiscountComponent[] =
            this.getDiscountCompsFromParent(fullBillDicountComponents)
          discountComp?.forEach((discount, index) => {
            const discountInfo = ProductDiscountCalc.getDiscountRecord(
              calAmount,
              discount,
              index
            )
            calAmount = discountInfo.amountAfterDiscount
            this.billDiscount.discountAmount += discountInfo.discountAmount
            this.billDiscount.discountsInfo.push(discountInfo)
          })
          this.billDiscount.amountAfterDiscount = calAmount
        } 
      }
    } catch (e) {
      console.error(e)
    }
  }
}

export { ProductDiscountCalc }
